import { render } from "./ExtraChargeCategoryForm.vue?vue&type=template&id=5584d37b"
import script from "./ExtraChargeCategoryForm.vue?vue&type=script&lang=js"
export * from "./ExtraChargeCategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__